module.exports = __webpack_public_path__ + "img/dcfk_content2.ee285b87.png";